export default __webpack_public_path__ + "static/media/hero14.afa43f89.png";